import React, { useState } from 'react'
import { Text, View, StyleSheet, Font } from '@react-pdf/renderer';

import bahijB from '../../assets/fonts/Bahij-Nazanin-Bold.ttf';

const widths = {
    no: "5%",
    desc: "35%",
    piece: "6%",
    bale: "6%",
    weight: "12%",
    qty: "12%",
    price: "10%",
    total: "15%",
}


const header = [

    { name: '#', style: { width: widths?.no } },
    { name: 'Item Description', style: { width: widths?.desc } },
    { name: 'Pieces', style: { width: widths?.piece } },
    { name: 'Bales', style: { width: widths?.bale } },
    { name: 'Weight (KG)', style: { width: widths?.weight } },
    { name: 'Qty (SQ.M)', style: { width: widths?.qty } },
    { name: 'Unit Price', style: { width: widths?.price } },
    { name: 'S.Total Price', style: { width: widths?.total } },
]

export default function Table({ v }) {
    return (
        <View style={styles.tableContainer}>
            <InvoiceTableHeader v={v} />
            <InvoiceTableRow v={v} />
        </View>
    )
}


const InvoiceTableHeader = ({ v }) => {
   // Font.register({ family: 'bahijB', src: bahijB });
    console.log('InvoiceTableHeader ', v);
    const borderColor = '#bf360c'
    const styles = StyleSheet.create({
        container: {
            flexDirection: 'row',
            backgroundColor: '#840302',
            color: '#fff',
            alignItems: 'center',
            justifyContent: 'center',
            flexGrow: 1,
            fontSize: 10,

        },

        cell: {
            borderRightWidth: 0.5,
            borderRightColor: borderColor,
            textAlign: 'center',
            fontWeight: 'bold', fontFamily: 'amiriB',

        }
    });

    return (
        <View style={styles.container}>
            {header?.map((h, i) => <Text key={i} style={{ ...styles.cell, ...h.style }}>{h.name}</Text>)}
        </View>

    );
}


const InvoiceTableRow = ({ v }) => {

    /* {item?.category?.value === 26 && item?.sort ? ": Sort (" + item?.sort + "), " : ""} */


    const getSplitText = (t) => t ? t.split(" ") : []
    const cn = (n) => v?.com?.numConvertAndRevrse(n)
    const nf = (n) => v?.com?.NumberFormatter(n)


    const borderColor = '#840302'
    const styles = StyleSheet.create({
        row: {
            flexDirection: 'row',
            borderBottomColor: '#840302',
            borderBottomWidth: 0.5,
            alignItems: 'center',
            margin: 0,
            fontSize: 9,
        },

        cell: {
            borderRightWidth: 0.5,
            textAlign: 'center',
            paddingLeft: "3px",
            borderRightColor: borderColor,
            fontSize: 9,
            padding: 3,

        },

        crossTotal: {
            fontWeight: 'bold', fontFamily: 'amiriB',
            borderRightWidth: 0.7,
            fontSize: 11,
            textAlign: 'center',
            borderRightColor: borderColor,
            borderTopColor: '#840302',
            borderTopWidth: 1,
        }
    });

    const rowData = (style, data='') => <Text style={{ ...styles.cell, ...style }} > {data}</Text>

    const rows = v?.items?.map((item, i) => {
        const amount = item?.price_per_unit * item.quantity;

        return (
            <View style={styles.row} key={i}>
                {rowData({ width: widths.no }, i + 1)}
                <Text style={{ ...styles.cell, width: widths.desc, textAlign: 'left', fontFamily: 'amiriR' }}>
                {item?.category?.name} {item?.description}</Text>
                {rowData({ width: widths.piece }, item?.pieces)}
                {rowData({ width: widths.bale }, item?.bales)}
                {rowData({ width: widths.weight }, nf(item?.weight))}
                {rowData({ width: widths.qty }, nf(item?.quantity))}
                {rowData({ width: widths.price },"$  "+ nf(item?.price_per_unit))}
                <View style={{display:'flex', flexDirection:'row',  justifyContent: 'space-between',width: widths.total, paddingLeft:5, }}> <Text>$</Text> {rowData({ paddingRight:5, }, nf(amount))}</View>

            </View>
        )
    })


    const grossRow = (
        <View style={styles.row}>
            <Text style={{ ...styles.crossTotal, width: '40%' }}>GROSS TOTAL</Text>
            <Text style={{ ...styles.crossTotal, width: '6%' }} >{v?.grossTotal?.pieces}</Text>
            <Text style={{ ...styles.crossTotal, width: '6%' }} >{v?.grossTotal?.bales}</Text>
            <Text style={{ ...styles.crossTotal, width: '12%' }} >{v?.grossTotal?.weight ?  nf(v?.grossTotal?.weight): '.'}</Text>
            <Text style={{ ...styles.crossTotal, width: '12%' }}>{nf(v?.grossTotal?.quantity)}</Text>
            <Text style={{ ...styles.crossTotal, width: '25%' }}> {nf(v?.grossTotal?.amount)} {v?.currency?.label}</Text>
        </View>)


    const blankRows = Array.from({ length: 5 - v?.items.length}, () => 0)//Array(v?.items.length>=7? 0: 4).fill(0)
    const emptyRows = blankRows.map((x, i) =>
        <View style={styles.row} key={`BR${i}`}>
          {rowData({ width: widths.no })}
          {rowData({ width: widths.desc })}
          {rowData({ width: widths.piece })}
          {rowData({ width: widths.bale })}
          {rowData({ width: widths.weight })}
          {rowData({ width: widths.qty })}
          {rowData({ width: widths.price })}
          {rowData({ width: widths.total })}

        </View>
    )
    return (<>{rows}  {emptyRows} {grossRow}</>)
};

const styles = StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        borderWidth: 1,
        borderColor: '#840302',
    },

});
